import { render } from "./MyProfile.vue?vue&type=template&id=9d7dc228&scoped=true&ts=true"
import script from "./MyProfile.vue?vue&type=script&lang=ts"
export * from "./MyProfile.vue?vue&type=script&lang=ts"

import "./MyProfile.vue?vue&type=style&index=0&id=9d7dc228&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d7dc228"]])

export default __exports__